<template>
  <InputHintWrapper :hint="hint" :is-hint-shown="isHintShown">
    <slot />
  </InputHintWrapper>
</template>

<script lang="ts" setup>
  // Components
  import InputHintWrapper from '~/misc/input/hint-wrapper/InputHintWrapper.vue';

  // Utils
  import { pluralize } from '~/misc/utils/number';

  const props = defineProps({
    inputValue: {
      type: String,
      required: true,
    },
    isHintShown: {
      type: Boolean,
      default: false,
    },
    minChars: {
      type: Number,
      required: true,
    },
  });

  const hint: ComputedRef<string> = computed<string>(() => {
    const valueLength: number = props.inputValue.trim().length;
    const minCharsSearch: number = props.minChars;

    if (!valueLength) {
      return `Min ${minCharsSearch} ${pluralize(minCharsSearch, 'char')}`;
    }

    const charsLeft: number = Math.max(minCharsSearch - valueLength, 0);

    if (charsLeft) {
      return `${charsLeft} more ${pluralize(charsLeft, 'char')} left`;
    }

    return '';
  });
</script>
